<template>
  <svg
    id="No_Setor"
    data-name="No Setor"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height ? height : width"
    viewBox="0 0 235.89 202.138"
  >
    <g
      id="Retângulo_15"
      data-name="Retângulo 15"
      transform="translate(0 26.138)"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="15"
    >
      <rect width="182" height="176" rx="35" stroke="none" />
      <rect x="7.5" y="7.5" width="167" height="161" rx="27.5" fill="none" />
    </g>
    <rect
      id="Retângulo_16"
      data-name="Retângulo 16"
      width="141"
      height="115"
      transform="translate(50 22.138)"
      fill="#fff"
    />
    <path
      id="Icon_awesome-folder-open"
      data-name="Icon awesome-folder-open"
      d="M179.329,77.835l-22.678,39.918a19.947,19.947,0,0,1-17.31,10.209H14.1a7.719,7.719,0,0,1-6.492-11.6L30.286,76.439A19.948,19.948,0,0,1,47.6,66.231H172.838a7.719,7.719,0,0,1,6.491,11.6ZM47.6,55.942H150.3V40.51a15.235,15.235,0,0,0-15.03-15.433h-50.1L65.132,4.5H15.03A15.235,15.235,0,0,0,0,19.933v89.4L21.63,71.255A30.023,30.023,0,0,1,47.6,55.942Z"
      transform="translate(55.526 -4.5)"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { required: false, type: String, default: '100%' },
    height: { required: false, type: String },
    color: { required: false, type: String, default: '#4e73df' }
  }
}
</script>
